<template lang="pug">
.element-view(
  :class='{ focus: isFocused }'
  :id='`element-${element.id}`'
  :style='getStyle()'
  v-if='!loading'
)
  template(v-if='element.category === "content"')
    .element-view__text(v-if='element.type === "text"') {{ element.value }}
    .element-view__comment(
      v-if='element.type === "comment"'
      v-tooltip:top='`Anotação do remetente`'
    )
      | {{ formatTextFieldWhenIsDate(element.value) }}
    .element-view__qr-code(
      v-if='element.type === "qr-code" || element.type === "validation-qrcode"'
    )
      img.img.img-fluid(
        :src='element.qr_code ? element.qr_code.src : "/images/qr-code.svg"'
        v-if='element.qr_code || element.type === "validation-qrcode"'
      )
    .element-view__image(v-if='element.type === "image"')
      img.img(:src='element.image.src')
  template(v-if='element.category === "field"')
    template(v-if='element.recipient.id === recipientId && !element.disabled')
      .element-view__field-input(
        v-if='element.type === "text"'
        v-tooltip:top='element.tooltip || ""'
      )
        input.input(
          :placeholder='element.title'
          @change='$emit("change", element)'
          type='text'
          v-model='element.value'
        )
      .element-view__field-select(
        v-if='element.type === "dropdown"'
        v-tooltip:top='element.tooltip || ""'
      )
        select.form-select(
          @change='$emit("change", element)'
          v-model='element.value'
        )
          option(disabled value='') {{ element.title }}
          option(
            :key='index'
            :value='option'
            v-for='(option, index) in element.options'
          ) {{ option }}
      .element-view__field-checkbox(
        v-if='element.type === "checkbox"'
        v-tooltip:top='element.tooltip || ""'
      )
        label.label(:for='element.id')
          input.form-check-input(
            :id='element.id'
            @change='$emit("change", element)'
            type='checkbox'
            v-model='element.value'
          )

      .element-view__field-signature(
        :class='{ "no-image": !element.value }'
        @click='$emit("signature-click", element); onClick()'
        style='cursor: pointer'
        v-if='element.type === "signature"'
      )
        div(v-if='!element.value')
          span.text {{ $t('modal.envelope.fields.fill.signature') }}
          div
            i.fas.fa-signature
          button.btn.btn-edit-field(
            @click.stop='$emit("edit-signature", element)'
          )
            i.fas.fa-pen
        img.img.img-fluid(:src='globalSignature || element.value' v-else)

      .element-view__field-initial(
        :class='{ "no-image": !element.value }'
        @click='$emit("initial-click", element); onClick()'
        style='cursor: pointer'
        v-if='element.type === "initial"'
      )
        div(v-if='!element.value')
          span.text {{ $t('modal.envelope.fields.fill.initial') }}
          div
            icon(name='file-signature')
          button.btn.btn-edit-field(
            @click.stop='$emit("edit-initial", element)'
          )
            i.fas.fa-pen
        img.img.img-fluid(:src='globalInitial || element.value' v-else)
    template(v-else)
      template(v-if='element.type === "signature"')
        .element-view__field-no-owner.d-flex(v-if='!element.value')
          .element-view__field-no-owner__content.my-auto
            .text {{ $t('modal.envelope.fields.signature') }}
            .text.cut-with-ellipsis {{ element.recipient.addressees[0].name }}
        .element-view__field-signature(v-else)
          img.img.img-fluid(:src='element.value')
      template(v-if='element.type === "initial"')
        .element-view__field-no-owner.d-flex(v-if='!element.value')
          .element-view__field-no-owner__content.my-auto
            .text {{ $t('modal.envelope.fields.initial') }}
            .text.cut-with-ellipsis {{ element.recipient.addressees[0].name }}
        .element-view__field-signature(v-else)
          img.img.img-fluid(:src='element.value')
      template(v-if='element.type === "checkbox"')
        .element-view__field-checkbox(
          v-tooltip:right='`${element.recipient.addressees[0].name} - ${element.title}`'
        )
          label.label(:for='element.id')
            input.form-check-input(
              :checked='element.value'
              :id='element.id'
              disabled
              type='checkbox'
            )
      template(v-if='["text", "dropdown"].includes(element.type)')
        .element-view__field-input(
          v-if='element.type === "text"'
          v-tooltip:top='`${element.recipient.addressees[0].name} - ${element.title}`'
        )
          input.input(
            :placeholder='element.title'
            :value='element.value'
            disabled
            type='text'
          )
</template>

<script>
import { parseISO, format } from 'date-fns';
import Icon from '../atoms/Icon.vue';

export default {
  name: 'DocumentElementViewerMobile',
  components: {
    Icon,
  },
  props: {
    element: Object,
    page: Object,
    recipientId: String,
    globalSignature: String,
    globalInitial: String,
    // Add scale prop
    scale: {
      type: Number,
      default: 1,
    },
  },
  data() {
    return {
      loading: true,
      fontSize: 16, // Keep if font size is needed
      parentSizeObserve: '',
      parentSizeObserveUpdateDelay: 100,
      loadedPageObserver: null,
      isFocused: false, // Keep if focus state is needed
    };
  },
  mounted() {
    setTimeout(() => {
      this.loading = false;
    }, 1000);
  },
  methods: {
    formatTextFieldWhenIsDate(element) {
      if (!element || !element.value || element.type !== 'date')
        return element ? element.value : '';
      try {
        const date = parseISO(element.value);
        return format(date, element.format || 'dd/MM/yyyy');
      } catch (error) {
        console.error('Error formatting date:', error);
        return element.value;
      }
    },
    // Ensure getStyle correctly calculates pixel values
    getStyle() {
      if (!this.element?.apiX || !this.page) {
        return {
          position: 'absolute',
          left: 0,
          top: 0,
          width: '100px',
          height: '100px',
        };
      }

      const scale = this.scale || 1;

      const scaledX = this.element.apiX * scale;
      const scaledY = this.element.apiY * scale;
      const scaledWidth = this.element.apiWidth * scale;
      const scaledHeight = this.element.apiHeight * scale;
      // TODO: Uncomment this when we have a way to test the element position
      //console.log(
      // `Element ID: ${this.element.id}, apiX: ${this.element.apiX}, apiY: ${this.element.apiY},` +
      // ` scale: ${scale}, scaledX: ${scaledX}, scaledY: ${scaledY}`
      //);

      return {
        position: 'absolute',
        left: `${scaledX}px`,
        top: `${scaledY}px`,
        width: `${scaledWidth}px`,
        height: `${scaledHeight}px`,
        transform: 'none',
        transformOrigin: 'top left',
        // Consider if font size should also scale
        'font-size': this.element.apiFontSize
          ? `${this.element.apiFontSize}px`
          : '16px',
      };
    },
    onClick() {
      // Keep original onClick logic
      if (this.element.category === 'field') {
        if (this.element.type === 'signature') {
          this.$emit('signature-click', this.element);
        } else if (this.element.type === 'initial') {
          this.$emit('initial-click', this.element);
        }
      }
    },
  },
};
</script>

<style lang="stylus">
.documents-pdf-viewer
  position: relative
  .pdf-thumbs
    height: calc(100vh - 255px)
  .elements-list
    position: absolute
    top: 0
    bottom: 0
    right: 0
    left: 0
    margin: auto
    z-index: 1
.field-focus
  cursor: pointer
  position: absolute
  top: 10%
  z-index: 2
  background-color: #013D52
  color: #fff
  font-size: .8rem
  text-align: center
  padding: 1em 1em 1.15em 1em
  line-height: 1em
  padding-right: 2.5em
  border-radius: 5px
  min-width: 85px
  clip-path: polygon(0% 0%, 75% 0%, 100% 50%, 75% 100%, 0% 100%);
  &:hover
    text-decoration: none
    color: #fff
    opacity: 1
    font-size: 1rem
    font-weight: 400
</style>
